// extracted by mini-css-extract-plugin
export var input = "currency-field-module--input--ar_iD";
export var symbolAfter = "currency-field-module--symbolAfter--1s7BV";
export var currencySymbol = "currency-field-module--currencySymbol--2WGtt";
export var wrap = "currency-field-module--wrap--YfHxI";